export default "__VITE_ASSET__DPSGVxZJ__"